import $ from 'jquery';
import Vars from '../../vars';
import Action from "../classes/DropzoneAction";

import Plan from "../modules/Plan";
import Request from "../../components/request";

export default {
    _state : {
        items : {}
    },

    _args : {
        item     : {},
        parent1  : {},
        parent2  : {},
        parent3  : {},
        entities : '',
        chess    : {},
        progress : {},
        mode     : ''
    },

    _setArgs : function(args) {
        let self = this;

        self._args.item     = args.item ? args.item : self._args.item;
        self._args.items    = args.items ? args.items : self._args.items;
        self._args.parent1  = args.parent1 ? args.parent1 : self._args.parent1;
        self._args.parent2  = args.parent2 ? args.parent2 : self._args.parent2;
        self._args.parent3  = args.parent3 ? args.parent3 : self._args.parent3;
        self._args.entities = args.entities ? args.entities : self._args.entities;
        self._args.chess    = args.chess ? args.chess : self._args.chess;
        self._args.progress = args.progress ? args.progress : self._args.progress;
        self._args.mode     = args.mode;
    },

    _plans : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/create?api_token=' + auth.user.api_token + '&mode=profile',
                addRemoveLinks     : true,
                paramName          : 'plan',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 20,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                if (response && response.error) return;
                if (!file.plan) file.plan = response ? response.plan : null;

                if (!file.plan) return;

                $('<input />').attr('type', 'hidden').attr('name', 'floor[plan_ids][]').val(file.plan.id).appendTo($file);

                item && $('<a />').addClass('dz-link').attr('href', file.plan.path_to_extra_large != '' ? file.plan.path_to_extra_large : file.plan.path_to_original).attr('target', '_blank').appendTo($file).click(function(event){
                    event.preventDefault();
                });

                new Plan({
                    mode     : 'floor',
                    section  : self._args.parent3,
                    building : self._args.parent2,
                    object   : self._args.parent1,
                    floors   : self._args.items,
                    item     : file.plan,
                    root     : $file,
                    done     : function(response){
                        file.plan = response.plan;
                        $file.find('.dz-information.count-of-polygons').html(file.plan.polygons.length);

                        self._args.parent3.floors.forEach(function (floor) {
                            floor.plans.forEach(function (plan, plan_index) {
                                if (plan.id != response.plan.id) {
                                    return;
                                }

                                floor.plans[plan_index] = response.plan;
                            });
                        });

                        self._args.chess._updateSections();
                        self._args.chess._updateStickySections();
                        self._args.chess._updateCurrentSection();

                        // self.progress.update();
                    },
                    update : function(){
                        return file.plan;
                    }
                });

                $('<div />').addClass('dz-information count-of-polygons').attr('title', 'Количество полигонов на изображении').appendTo($file).each(function() {
                    $(this).html(file.plan.polygons.length);
                }).click(function(event) {
                    event.preventDefault();
                    $file.find('.dz-link').trigger('click');
                });

                let actions = {
                    remove : {
                        isLink : true,
                        confirmation: true,
                        args      : {
                            title        : 'Удаление изображения',
                            confirmation : {
                                title : 'это изображение'
                            }
                        }
                    },
                    rotate90 : {
                        isLink : true,
                        url  : function(file) {
                            return '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                        },
                        data: {
                            angle: 270
                        }
                    },
                    rotate270 : {
                        isLink : true,
                        url  : function(file) {
                            return '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                        },
                        data : {
                            angle: 90
                        }
                    }
                };

                new Action({
                    actions  : actions,
                    dropzone : dropzone,
                    file     : file,
                    entity   : 'plan',
                    done     : function (f) {
                        file.plan = f.plan;
                        $file.find('.dz-link').trigger('update');
                    }
                });

                $file.find('.dz-image').css('background-image', 'url(\'/' + (file.plan.path_to_small != '' ? file.plan.path_to_small : file.plan.path_to_original) + '\')');
                $file.find('.dz-image img').remove();
            },
            done: function(dropzone){
                Object.keys(self._args.item).length && self._args.item.plans && self._args.item.plans.forEach(function(plan) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.plan = plan;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    _parkingPlans : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/create?api_token=' + auth.user.api_token + '&mode=profile',
                addRemoveLinks     : true,
                paramName          : 'plan',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 20,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){

                let $file = $(file._removeLink).parent();
                if (response && response.error) return;
                if (!file.plan) file.plan = response ? response.plan : null;

                if (!file.plan) return;

                $('<input />').attr('type', 'hidden').attr('name', 'floor[parking_plan_ids][]').val(file.plan.id).appendTo($file);

                item && $('<a />').addClass('dz-link').attr('href', file.plan.path_to_extra_large != '' ? file.plan.path_to_extra_large : file.plan.path_to_original).attr('target', '_blank').appendTo($file).click(function(event){
                    event.preventDefault();
                });

                let actions = {
                    remove : {
                        isLink       : true,
                        confirmation : true,
                        args         : {
                            title        : 'Удаление изображения',
                            confirmation : {
                                title : 'это изображение'
                            }
                        }
                    },
                    rotate90 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                        },
                        data   : {
                            angle: 270
                        }
                    },
                    rotate270 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent1.id + '/buildings/' + self._args.parent2.id + '/sections/' + self._args.parent3.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                        },
                        data   : {
                            angle: 90
                        }
                    }
                };

                new Action({
                    actions  : actions,
                    dropzone : dropzone,
                    file     : file,
                    entity   : 'plan'
                });

                $file.find('.dz-image').css('background-image', 'url(\'/' + (file.plan.path_to_small != '' ? file.plan.path_to_small : file.plan.path_to_original) + '\')');
                $file.find('.dz-image img').remove();
            },
            done: function(dropzone, item){
                Object.keys(self._args.item).length && self._args.item.parking_plans && self._args.item.parking_plans.forEach(function(plan) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.plan = plan;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        };
    },

    get : function(args) {
        let self = this;

        self._setArgs(args);

        if (self._args.mode == 'plans') {
            return self._plans();
        } else if (self._args.mode == 'parking_plans') {
            return self._parkingPlans();
        }
    },
}